var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "upgrade-page" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._l(_vm.packagelist, function(item, index) {
        return _c(
          "section",
          { key: item.newPackageID || index, staticClass: "upgrade-card" },
          [
            _c("div", { staticClass: "price-row" }, [
              _c(
                "label",
                {
                  staticClass: "select-wrap",
                  attrs: { "aria-label": "选择升级套餐" }
                },
                [
                  _c("input", {
                    staticClass: "select-radio",
                    attrs: { type: "radio", name: "upgrade-plan" },
                    domProps: { checked: _vm.checked === index },
                    on: {
                      change: function($event) {
                        _vm.checked = index
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "select-dot",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "price-col" }, [
                _c("p", { staticClass: "price-main" }, [
                  _vm._v(_vm._s(_vm.nowPackage.price))
                ]),
                _c("p", { staticClass: "price-sub" }, [
                  _vm._v(_vm._s(_vm.nowPackage.title))
                ])
              ]),
              _vm._v(" "),
              _c("img", {
                staticClass: "arrow-icon",
                attrs: {
                  src: require("./static/images/package-upgrade/jiantou.png"),
                  alt: "",
                  "aria-hidden": "true"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "price-col" }, [
                _c("p", { staticClass: "price-main" }, [
                  _vm._v(_vm._s(item.price))
                ]),
                _c("p", { staticClass: "price-sub" }, [
                  _vm._v(_vm._s(item.title))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "price-col price-col--cta" }, [
                _c("p", { staticClass: "price-main price-main--red" }, [
                  _vm._v(_vm._s(item.diff))
                ]),
                _c(
                  "button",
                  {
                    staticClass: "buy-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.submit(item)
                      }
                    }
                  },
                  [_vm._v("升级购买")]
                )
              ])
            ])
          ]
        )
      }),
      _vm._v(" "),
      _vm._m(1)
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "upgrade-header" }, [
      _c("div", { staticClass: "upgrade-header-glow" }),
      _vm._v(" "),
      _c("h1", [_vm._v("套餐升级")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "tips" }, [
      _c("h2", [_vm._v("温馨提示")]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [_vm._v("网络服务由当地优质运营商提供，安全靠谱。")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "购买后30天之内随时启用，有效期将从启用后开始计算，每24小时计为1天，一经启用，无法暂停计时。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "购买后使用30天以内，可在公众号联系客服取消订单；在海岛、隧道、山区、高速公路、沙漠等偏远地区，可能会出现信号较弱和信号丢失。"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "开启热点共享时，建议关闭接入手机的同步、备份等功能，避免套餐流量消耗过快。"
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0364c682", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0364c682","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newpage/shengji.vue
// module id = null
// module chunks = 